import * as Yup from "yup";
import { addMinutes, format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { useFormik, FormikHelpers } from "formik";
import { useTimeZoneContext } from "../../../lib/context/TimeZone/TimeZoneContext";

import { SearchWorkplaceFields } from "../../../views/Bookings/types";
import {
  BOOKING_INTERVAL,
  GENERAL_STRINGS,
} from "../../../lib/utils/constants";

interface UseSearchRoomsFormOptions {
  initialValues?: SearchWorkplaceFields;
  enableReinitialize?: boolean;
  onSubmit: (
    values: SearchWorkplaceFields,
    formikHelpers: FormikHelpers<SearchWorkplaceFields>
  ) => Promise<any>;
}

const SearchWorkplaceSchema = Yup.object().shape({
  subject: Yup.string().required(GENERAL_STRINGS.subjectRequired),
});

export type SearchRoomsFormik = ReturnType<typeof useSearchRoomsFormik>;

export const useSearchRoomsFormik = (opts: UseSearchRoomsFormOptions) => {
  const { timeZone } = useTimeZoneContext();

  return useFormik<SearchWorkplaceFields>({
    initialValues: {
      day: {
        label: `Today, ${format(
          toZonedTime(new Date(), timeZone),
          "MMM dd"
        )}`,
        value: format(toZonedTime(new Date(), timeZone), "yyyy-MM-dd"),
      },
      from: toZonedTime(new Date(), timeZone), //new Date(),
      until: toZonedTime(addMinutes(new Date(), BOOKING_INTERVAL), timeZone),
      tags: [],
      minNrSeats: 0,
      maxNrSeats: 0,
      equipment: false,
      subject: "",
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: SearchWorkplaceSchema,
    onSubmit: async (values, fromikHelpers) => {
      await opts.onSubmit(values, fromikHelpers);
    },
  });
};
